import React from "react";
import {Row, Col, Container} from 'react-bootstrap';
import { FormattedMessage, injectIntl } from "react-intl";

const Footer = (props) => {
    const { intl } = props;
    return (
        <footer className="site-footer">
            <Container>
                <Row className="justify-content-center">
                    <Col style={{ textAlign: 'center'}}>
                        <span><FormattedMessage  id={"footer"}/></span> &nbsp;
                        <span style={{ color: '#2E3192' }}><FormattedMessage  id={"footer_hotline"}/></span>
                    </Col>
                </Row>
            </Container>
        </footer>
    );
}
export default injectIntl(Footer);